import { useProjects } from '../hooks/useProjects';
import { Spinner } from './ui/Spinner';
import type { Project } from '@pantheon/shared';

export interface ProjectSelectorProps {
  value?: string;
  onChange: (project: Project | null) => void;
  className?: string;
}

export function ProjectSelector({ value, onChange, className = '' }: ProjectSelectorProps) {
  const { projects, loading, error } = useProjects();

  if (loading) {
    return (
      <div className={`flex items-center gap-2 text-sm text-gray-500 ${className}`}>
        <Spinner size="sm" /> Loading projects...
      </div>
    );
  }

  if (error) {
    return <div className={`text-sm text-danger ${className}`}>Error: {error}</div>;
  }

  return (
    <select
      className={`w-full px-3 py-2 rounded-lg border border-gray-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary ${className}`}
      value={value ?? ''}
      onChange={(e) => {
        const project = projects.find((p) => p.projectId === e.target.value);
        onChange(project ?? null);
      }}
    >
      <option value="">Select a project...</option>
      {projects.map((project) => (
        <option key={project.projectId} value={project.projectId}>
          {project.name}
        </option>
      ))}
    </select>
  );
}
